import(/* webpackMode: "eager" */ "/home/forge/vermut-apps-releases/website/22-07-2025-12-04-06/apps/website/src/app/global-error.tsx");
